import { Component } from "react";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./landing-page.css";

class LandingPage extends Component {
  render() {
    return (
      <Container id="start" className="h-100 px-md-3 p-0 bg-dark" fluid>
        <div
          className="d-md-none d-block h-100 pt-5 text-center text-light"
          id="mobile-body"
        >
          <div className="pt-5"></div>
          <Image
            className="profile-image"
            src={require("../../Images/zaid.png")}
            width="150"
          />
          <h2 className="pt-3 mt-4">Hola mate,</h2>
          <h3>My name is Zaid Khan</h3>
          <h6>I'm a Full Stack Web developer and UI/UX designer</h6>
          <a className="pr-2" href="https://www.github.com/triquetrx">
            <i className="text-dark fa-brands fa-lg fa-github"></i>
          </a>
          <a className="pr-2" href="https://twitter.com/triquetrx">
            <i className="text-dark fa-brands fa-lg fa-twitter"></i>
          </a>
          <a className="pr-2" href="httpss://www.linkedin.com/in/zikhere">
            <i className="text-danger fa-brands fa-lg fa-linkedin"></i>
          </a>
          <a href="https://www.behance.net/triquetrx" className="text-danger">
            <i className="fa-brands fa-behance fa-lg"></i>
          </a>
          <br />
          <Link className="text-light" to="/about">
            <i className="pt-5 fa-2x fa-solid fa-angles-down"></i>
          </Link>
        </div>
        <div className="h-100 d-none d-md-block" id="landing-page-data">
          <Row className="h-100">
            <Col className="d-md-block d-none mt-md-5 pl-5 text-light">
              <br />
              <h3 className="pt-5 mt-5 pb-0">Hi,</h3>
              <h3>My name is Zaid Khan</h3>
              <h6>I'm a Full Stack Web developer and UI/UX designer</h6>
              <a className="pr-2" href="https://www.github.com/triquetrx">
                <i className="text-danger fa-brands fa-lg fa-github"></i>
              </a>
              <a className="pr-2" href="https://twitter.com/triquetrx">
                <i className="text-danger fa-brands fa-lg fa-twitter"></i>
              </a>
              <a className="pr-2" href="https://www.linkedin.com/in/zikhere">
                <i className="text-danger fa-brands fa-lg fa-linkedin"></i>
              </a>
              <a
                href="https://www.behance.net/triquetrx"
                className="text-danger"
              >
                <i className="fa-brands fa-behance fa-lg"></i>
              </a>
            </Col>
            <Col className="bg-danger d-none d-md-block border-0" md="4">
              <div className="mt-5 pt-5"></div>
              <Image
                className="profile-image d-none d-md-block"
                src={require("../../Images/zaid.png")}
                width="300"
              />
              <Link
                className="mt-5 pt-5 text-light"
                to="/about"
                id="arrow-down"
              >
                <i className="mt-5 pt-5 fa-2x fa-solid fa-angles-down"></i>
              </Link>
            </Col>
          </Row>
        </div>
      </Container>
    );
  }
}

export default LandingPage;
